import React, { useState, useContext, useEffect, useRef } from "react";
import { Table, Button } from "reactstrap";
import { FileMinus } from "lucide-react";
import { AppContext } from '../application/provider';
import Loader from "../components/Loader/Loader";
import { ButtonSearch } from '../components/Buttons/Buttons';
import ButtonPdf from '../components/Buttons/ButtonPdf';
import ButtonExcel from '../components/Buttons/ButtonExcel';
import ButtonInsert from '../components/Buttons/ButtonInsert';
import ButtonUpdate from '../components/Buttons/ButtonUpdate';
import ModalRegistroPagoRhAdministracion from '../components/Modal/ModalRegistroPagoRhAdministracion';
import ModalEstadoPagoRhAdministracion from '../components/Modal/ModalEstadoPagoRhAdministracion';
import ModalAgregarRhAdministracion from '../components/Modal/ModalAgregarRhAdministracion';
import "./CargoPago.css";

import RhAdministracionService from "../axios_services/rh_administracion.service";
import ArchivosService from "../axios_services/archivos.service";

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const DEFAULT_ROWS = [
    {
        rh_administracion_id: null, area: 'ADMINISTRATIVO', apellidos_nombre: 'RAMIREZ TAIPE ALEXANDER MAXIMO',
        cargo: 'GESTOR DE PROYECTOS', empresa_id: 1, rxh_factura: 'E001-', pago_mes: 1000, bono_gestion: 0, descuento: 0,
        importe_neto: 1000, detraccion: 0, dni: '45121137', n_cuenta: '107013211001733001',
        cci: '80801321100173300175', banco_pago: 'CAJA HUANCAYO', n_cuenta_detraccion: '', banco_detraccion: '',
        fecha_pago: null, boleta_url: null
    },
    {
        rh_administracion_id: null, area: 'EMPRESA', apellidos_nombre: 'INNOVA NETWORKING SAC',
        cargo: '', empresa_id: 1, rxh_factura: 'E001-', pago_mes: 1500, bono_gestion: 0, descuento: 0,
        importe_neto: 1320, detraccion: 180, dni: '44894675', n_cuenta: '107002211012998307',
        cci: '80800221101299830703', banco_pago: 'CAJA HUANCAYO', n_cuenta_detraccion: '00386041881', banco_detraccion: 'NACION',
        fecha_pago: null, boleta_url: null
    },
    {
        rh_administracion_id: null, area: 'ADMINISTRATIVO', apellidos_nombre: 'HUATUCO RIVERA RODOLFO MARCELO',
        cargo: 'ASESOR CONTABLE', empresa_id: 1, rxh_factura: 'E001-', pago_mes: 1000, bono_gestion: 0, descuento: 0,
        importe_neto: 1000, detraccion: 0, dni: '28718998', n_cuenta: '8983135051561',
        cci: '00389801313505156148', banco_pago: 'INTERBANK', n_cuenta_detraccion: '', banco_detraccion: '',
        fecha_pago: null, boleta_url: null
    },
    {
        rh_administracion_id: null, area: 'ADMINISTRATIVO', apellidos_nombre: 'HUATUCO RIVERA RODOLFO MARCELO',
        cargo: 'ASESOR CONTABLE', empresa_id: 2, rxh_factura: 'E001-', pago_mes: 200, bono_gestion: 0, descuento: 0,
        importe_neto: 200, detraccion: 0, dni: '28718998', n_cuenta: '8983135051561',
        cci: '00389801313505156148', banco_pago: 'INTERBANK', n_cuenta_detraccion: '', banco_detraccion: '',
        fecha_pago: null, boleta_url: null
    }
];

function RHAdministracion() {
    const [state] = useContext(AppContext);
    const [periodo_fecha, setPeriodoFecha] = useState(() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    });

    const [loading, setLoading] = useState(true);
    const [planillaData, setPlanillaData] = useState([]);
    const [validationStatus, setValidationStatus] = useState(null);
    const [registroPagoModal, setRegistroPagoModal] = useState(false);
    const [estadoPagoModal, setEstadoPagoModal] = useState(false);
    const [selectedItemPago, setSelectedItemPago] = useState(null);
    const [agregarModal, setAgregarModal] = useState(false);

    const empresaOptions = state?.catalogos?.tipos?.filter(t => Number(t.categoria_id) === 37) || [];

    const fetchDatos = async () => {
        setLoading(true);
        try {
            const dbPlanilla = await RhAdministracionService.getPlanillaRh(periodo_fecha).catch(() => []);
            const arrDbPlanilla = Array.isArray(dbPlanilla) ? dbPlanilla : (dbPlanilla?.data || Object.values(dbPlanilla || {}) || []);

            const boletasData = await ArchivosService.getBoletasPagoPeriodo(periodo_fecha).catch(() => []);
            const arrBoletas = Array.isArray(boletasData) ? boletasData : (boletasData?.data || []);
            const comprobantesData = await ArchivosService.getComprobantesPagoPeriodo(periodo_fecha).catch(() => []);
            const arrComprobantes = Array.isArray(comprobantesData) ? comprobantesData : (comprobantesData?.data || []);

            const validationRow = arrDbPlanilla.find(p => p && (p.aprobado_th || p.aprobado_sa || p.aprobado_gg)) || arrDbPlanilla[0];
            const isThAprob = validationRow ? validationRow.aprobado_th : 0;
            const isSaAprob = validationRow ? validationRow.aprobado_sa : 0;
            const isGgAprob = validationRow ? validationRow.aprobado_gg : 0;

            const computedData = arrDbPlanilla.map((dbRow) => {
                const rowData = {
                    ...dbRow,
                    apellidos_nombre: dbRow.apellidos_nombre || '',
                    area: dbRow.area || '',
                    cargo: dbRow.cargo || '',
                    rxh_factura: dbRow.rxh_factura || 'E001-',
                    empresa_id: dbRow.empresa_id || 1,
                    pago_mes: parseFloat(dbRow.pago_mes || 0),
                    bono_gestion: parseFloat(dbRow.bono_gestion || 0),
                    descuento: parseFloat(dbRow.descuento || 0),
                    importe_neto: parseFloat(dbRow.importe_neto || 0),
                    detraccion: parseFloat(dbRow.detraccion || 0)
                };

                const boleta = arrBoletas.find(b =>
                    (Number(b.origen_id) === Number(dbRow.rh_administracion_id)) ||
                    (Number(b.usuario_id) === Number(dbRow.rh_administracion_id))
                );
                const comprobante = arrComprobantes.find(c =>
                    (Number(c.origen_id) === Number(dbRow.rh_administracion_id)) ||
                    (Number(c.usuario_id) === Number(dbRow.rh_administracion_id))
                );
                rowData.boleta_url = boleta ? boleta.url_completa : null;
                rowData.comprobante_url = comprobante ? comprobante.url_completa : null;
                rowData.fecha_pago_db = rowData.fecha_pago;

                return rowData;
            });

            if (computedData.length > 0) {
                setPlanillaData(computedData);
                setValidationStatus({
                    aprobado_th: isThAprob,
                    aprobado_sa: isSaAprob,
                    aprobado_gg: isGgAprob
                });
            } else {
                setPlanillaData([]);
                setValidationStatus(null);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            setPlanillaData([]);
            setValidationStatus(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDatos();
    }, [state.catalogos]);

    const handleSearch = () => {
        fetchDatos();
    };

    const handleAddRow = () => {
        setAgregarModal(true);
    };

    const handleSaveRow = async (formData) => {
        setLoading(true);
        try {
            await RhAdministracionService.guardarPlanillaRh({
                periodo_planilla: periodo_fecha,
                registros: [formData]
            });
            alert('Registro guardado correctamente.');
            await fetchDatos();
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e, index, field) => {
        const val = e.target.value;
        const newData = [...planillaData];
        const numericFields = ['pago_mes', 'bono_gestion', 'descuento', 'detraccion', 'empresa_id'];

        if (numericFields.includes(field)) {
            newData[index][field] = field === 'empresa_id' ? parseInt(val) : parseFloat(val) || 0;

            if (field !== 'empresa_id') {
                const row = newData[index];
                row.importe_neto = (row.pago_mes - row.descuento) + row.bono_gestion - row.detraccion;
            }
        } else {
            newData[index][field] = val;
        }

        setPlanillaData(newData);
    };

    const handleAprobar = async () => {
        if (!window.confirm("¿Está seguro de que desea aprobar y firmar la planilla RH? Se registrarán todos los datos manuales actuales.")) {
            return;
        }
        setLoading(true);
        try {
            const payload = {
                periodo_planilla: periodo_fecha,
                registros: planillaData.map(d => ({
                    rh_administracion_id: d.rh_administracion_id,
                    area: d.area,
                    apellidos_nombre: d.apellidos_nombre,
                    cargo: d.cargo,
                    empresa_id: d.empresa_id,
                    pago_mes: d.pago_mes,
                    bono_gestion: d.bono_gestion,
                    descuento: d.descuento,
                    importe_neto: d.importe_neto,
                    detraccion: d.detraccion,
                    dni: d.dni,
                    n_cuenta: d.n_cuenta,
                    cci: d.cci,
                    banco_pago: d.banco_pago,
                    n_cuenta_detraccion: d.n_cuenta_detraccion,
                    banco_detraccion: d.banco_detraccion,
                    fecha_pago: d.fecha_pago
                }))
            };
            await RhAdministracionService.guardarPlanillaRh(payload);

            const perfilId = Number(state.user.perfil_id);
            await RhAdministracionService.validarPlanillaRh(periodo_fecha, perfilId);

            alert("Planilla RH aprobada correctamente.");
            await fetchDatos();
        } catch (error) {
            alert("Error al procesar la aprobación: " + (error.response?.data?.error || error.message));
        } finally {
            setLoading(false);
        }
    };

    const formatSoles = (val) => new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format(val || 0);
    const userProfile = Number(state.user?.perfil_id);
    const showBtnRegistro = [5, 8, 22, 26].includes(userProfile);
    const showBtnEstado = [8, 21, 12, 26].includes(userProfile);
    const totalImporteNeto = planillaData.reduce((sum, row) => sum + (Number(row.importe_neto) || 0), 0);

    const getStatusText = () => {
        if (!validationStatus) return "PENDIENTE";
        if (Number(validationStatus.aprobado_gg) === 1) return "APROBADO POR GERENCIA GENERAL";
        if (Number(validationStatus.aprobado_sa) === 1) return "APROBADO POR SUBGERENCIA ADMINISTRATIVA";
        if (Number(validationStatus.aprobado_th) === 1) return "APROBADO POR TALENTO HUMANO";
        return "PENDIENTE";
    };

    const getRowClass = (row) => {
        if (Number(validationStatus?.aprobado_gg) === 1) return 'row-validado';
        if (Number(validationStatus?.aprobado_sa) === 1) return 'row-validado';
        if (Number(validationStatus?.aprobado_th) === 1) return 'row-validado';
        if (row.rh_administracion_id) return 'row-registrado';
        return '';
    };

    const isApprovalDisabled = () => {
        if (!state.user) return true;
        const perfil = Number(state.user.perfil_id);
        const { aprobado_th, aprobado_sa, aprobado_gg } = validationStatus || {};

        if ([5, 8].includes(perfil)) return Number(aprobado_th) === 1;
        if (perfil === 26) return Number(aprobado_sa) === 1;
        if (perfil === 9) return Number(aprobado_sa) !== 1 || Number(aprobado_gg) === 1;
        return true;
    };

    const getEmpresaName = (id) => {
        const opt = empresaOptions.find(o => Number(o.tipo_id) === Number(id));
        if (!opt) return 'N/A';
        return (opt.descripcion || opt.nombre || 'N/A').toUpperCase();
    };

    const isExportEnabled = Number(validationStatus?.aprobado_gg) === 1;

    const exportToPDF = async () => {
        const doc = new jsPDF('landscape', 'pt', 'a4');
        const getMonthName = (YYYY_MM) => {
            if (!YYYY_MM) return '';
            const [y, m] = YYYY_MM.split('-');
            const date = new Date(Number(y), Number(m) - 1, 1);
            return date.toLocaleString('es-PE', { month: 'long', year: 'numeric' }).toUpperCase();
        };
        const monthYearStr = getMonthName(periodo_fecha);

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text("MEC BUSINNES PARTNER S.A.C.", 28, 30);
        doc.text("20612796484", 28, 45);

        const tableColumnNames = [
            "N°", "AREA", "APELLIDOS Y NOMBRES", "CARGO", "EMPRESA", "RxH / FACTURA", `TOTAL A PAGAR MES ${monthYearStr.split(' ')[0]}`, "BONO POR GESTIÓN",
            { content: "Descuento Tardanza", styles: { fillColor: [255, 0, 0], textColor: [255, 255, 255] } },
            { content: "IMPORTE NETO A PAGAR", styles: { fillColor: [255, 255, 0], textColor: [0, 0, 0] } },
            "DETRACCIÓN", "N° DNI", "N° CUENTA", "CCI", "BANCO", "N° CUENTA DE DETRACCIÓN", "BANCO",
            { content: "Fecha de pago", styles: { fillColor: [225, 213, 231], textColor: [0, 0, 0] } }
        ];

        const formatNumber = (val) => {
            if (val === 0 || !val) return "S/ -";
            return new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN', minimumFractionDigits: 2 }).format(val);
        };

        const tableRows = planillaData.map((row, index) => [
            index + 1,
            row.area?.toUpperCase(),
            row.apellidos_nombre?.toUpperCase(),
            row.cargo?.toUpperCase(),
            getEmpresaName(row.empresa_id),
            row.rxh_factura || "E001-",
            formatNumber(row.pago_mes),
            formatNumber(row.bono_gestion),
            formatNumber(row.descuento),
            { content: formatNumber(row.importe_neto), styles: { fillColor: [255, 255, 204], textColor: [0, 0, 0], fontStyle: 'bold' } },
            formatNumber(row.detraccion),
            row.dni,
            row.n_cuenta,
            row.cci,
            row.banco_pago?.toUpperCase(),
            row.n_cuenta_detraccion,
            row.banco_detraccion?.toUpperCase(),
            row.fecha_pago || ""
        ]);

        const totalRow = Array(18).fill("");
        totalRow[9] = formatNumber(totalImporteNeto);
        tableRows.push(totalRow);

        autoTable(doc, {
            startY: 60,
            head: [
                [{
                    content: `CARGO DE PAGO ${monthYearStr} - PERSONAL ADMINISTRATIVO / COMERCIAL /INNOVA`,
                    colSpan: 18,
                    styles: { halign: 'center', fillColor: [255, 192, 0], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 9, lineColor: [0, 0, 0], lineWidth: 0.5 }
                }],
                tableColumnNames
            ],
            body: tableRows,
            theme: 'grid',
            styles: { fontSize: 5, cellPadding: 1.5, overflow: 'linebreak', halign: 'center', valign: 'middle', lineColor: [0, 0, 0], lineWidth: 0.5 },
            margin: { left: 20, right: 20 },
            headStyles: { fillColor: [220, 220, 220], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 5, lineColor: [0, 0, 0], lineWidth: 0.5 },
            columnStyles: {
                2: { halign: 'left', cellWidth: 70 },
                1: { cellWidth: 35 },
                5: { cellWidth: 35 }
            },
            didParseCell: function (data) {
                if (data.section === 'body' && data.row.index === tableRows.length - 1) {
                    data.cell.styles.fontStyle = 'bold';
                    data.cell.styles.fillColor = [255, 255, 255];
                }
            }
        });

        const finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY : 100;
        let startY = finalY + 110;
        if (startY > doc.internal.pageSize.height - 70) { doc.addPage(); startY = 70; }

        try {
            /*
            // =========================================================================
            // CODIGO ANTERIOR (3 FIRMAS CON TALENTO HUMANO / PERFIL 5)
            // Para reactivar cuando el perfil 5 vuelva a operar con jefatura independiente:
            // =========================================================================
            // const [firmaThRes, firmaGgRes, firmaSaRes] = await Promise.all([
            //     ArchivosService.getFirmaDigitalConvenio(88).catch(() => null),
            //     ArchivosService.getFirmaDigitalConvenio(132).catch(() => null),
            //     ArchivosService.getFirmaDigitalConvenio(251).catch(() => null)
            // ]);
            // const firmaThB64 = firmaThRes?.base64 || null;
            // const firmaGgB64 = firmaGgRes?.base64 || null;
            // const firmaSaB64 = firmaSaRes?.base64 || null;
            // const pageWidth = doc.internal.pageSize.width;
            // const center1 = pageWidth * 0.25; const center2 = pageWidth * 0.50; const center3 = pageWidth * 0.75;
            // doc.setFontSize(7);
            // const drawSignature = (b64, name, role, cx, y) => {
            //     if (b64) {
            //         const format = b64.includes('image/jpeg') || b64.includes('image/jpg') || b64.includes('data:image/jpeg') ? 'JPEG' : 'PNG';
            //         doc.addImage(b64, format, cx - 50, y - 50, 100, 50);
            //     }
            //     doc.setLineWidth(0.5);
            //     doc.line(cx - 75, y, cx + 75, y);
            //     doc.setFont("helvetica", "bold"); doc.text(role, cx, y + 12, { align: 'center' });
            //     doc.setFont("helvetica", "normal"); doc.text(name, cx, y + 22, { align: 'center' });
            // };
            // drawSignature(firmaGgB64, "RAMIREZ TAIPE MANUEL ANGEL", "GERENTE GENERAL", center1, startY);
            // drawSignature(firmaSaB64, "ROSALES SAMANIEGO GABRIELA PATRICIA", "SUB GERENTE DE ADMINISTRACIÓN", center2, startY);
            // drawSignature(firmaThB64, "CHIPANA GAGO FLERIDA DANIELA", "JEFE DE TALENTO HUMANO", center3, startY);
            // =========================================================================
            */

            // CONFIGURACIÓN ACTUAL (ADMINISTRADO POR SUB GERENCIA DE ADMINISTRACIÓN - PERFIL 26)
            const [firmaGgRes, firmaSaRes] = await Promise.all([
                ArchivosService.getFirmaDigitalConvenio(132).catch(() => null),
                ArchivosService.getFirmaDigitalConvenio(251).catch(() => null)
            ]);
            const firmaGgB64 = firmaGgRes?.base64 || null;
            const firmaSaB64 = firmaSaRes?.base64 || null;
            const pageWidth = doc.internal.pageSize.width;
            const center1 = pageWidth * 0.35;
            const center2 = pageWidth * 0.65;

            doc.setFontSize(7);
            const drawSignature = (b64, name, role, cx, y) => {
                if (b64) {
                    const format = b64.includes('image/jpeg') || b64.includes('image/jpg') || b64.includes('data:image/jpeg') ? 'JPEG' : 'PNG';
                    doc.addImage(b64, format, cx - 50, y - 50, 100, 50);
                }
                doc.setLineWidth(0.5);
                doc.line(cx - 75, y, cx + 75, y);
                doc.setFont("helvetica", "bold"); doc.text(role, cx, y + 12, { align: 'center' });
                doc.setFont("helvetica", "normal"); doc.text(name, cx, y + 22, { align: 'center' });
            };

            drawSignature(firmaSaB64, "ROSALES SAMANIEGO GABRIELA PATRICIA", "SUB GERENTE DE ADMINISTRACIÓN", center1, startY);
            drawSignature(firmaGgB64, "RAMIREZ TAIPE MANUEL ANGEL", "GERENTE GENERAL", center2, startY);
        } catch (e) { }

        doc.save(`cargo_rh_administracion_${periodo_fecha.replace('-', '_')}.pdf`);
    };

    const exportToExcel = async () => {
        const getMonthName = (YYYY_MM) => {
            if (!YYYY_MM) return '';
            const [y, m] = YYYY_MM.split('-');
            const date = new Date(Number(y), Number(m) - 1, 1);
            return date.toLocaleString('es-PE', { month: 'long', year: 'numeric' }).toUpperCase();
        };
        const monthYearStr = getMonthName(periodo_fecha);

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('RH Administracion Manual');

        worksheet.getRow(1).values = ['MEC BUSINNES PARTNER S.A.C.'];
        worksheet.getRow(2).values = ['20612796484'];
        worksheet.mergeCells('A4:Q4');
        worksheet.getCell('A4').value = `RH ADMINISTRACIÓN PLANILLA DE ${monthYearStr}`;
        worksheet.getCell('A4').alignment = { horizontal: 'center' };

        const headers = [
            "N°", "AREA", "APELLIDOS Y NOMBRE", "CARGO", "EMPRESA", "RxH / FACTURA", `TOTAL A PAGAR MES ${monthYearStr.split(' ')[0]}`, "BONO POR GESTIÓN", "Descuento Tardanza", "IMPORTE NETO A PAGAR",
            "DETRACCIÓN", "DNI", "N° CUENTA", "CCI", "BANCO", "N° CUENTA DE DETRACCIÓN", "BANCO", "Fecha de pago"
        ];
        worksheet.getRow(5).values = headers;
        worksheet.getRow(5).font = { bold: true };

        planillaData.forEach((row, index) => {
            worksheet.addRow([
                index + 1, row.area, row.apellidos_nombre, row.cargo, getEmpresaName(row.empresa_id), row.rxh_factura || 'E001-', row.pago_mes, row.bono_gestion, row.descuento, row.importe_neto,
                row.detraccion, row.dni, row.n_cuenta, row.cci, row.banco_pago, row.n_cuenta_detraccion, row.banco_detraccion, row.fecha_pago
            ]);
        });

        const totalRowVal = Array(18).fill("");
        totalRowVal[9] = totalImporteNeto;
        const excelTotalRow = worksheet.addRow(totalRowVal);
        excelTotalRow.font = { bold: true };
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `RH_Administracion_Manual_${periodo_fecha}.xlsx`);
    };

    return (
        <div className="cargo-pago-module">
            {loading && <Loader />}
            <div className="flex items-center justify-between mb-4">
                <h1>RECIBO POR HONORARIOS - ADMINISTRACIÓN</h1>
                <div className="flex gap-2">
                    <ButtonPdf onClick={exportToPDF} disabled={loading || planillaData.length === 0 || !isExportEnabled} />
                    <ButtonExcel onClick={exportToExcel} disabled={loading || planillaData.length === 0 || !isExportEnabled} />
                </div>
            </div>
            <div className="filtros">
                <div>
                    <label>Periodo de fecha:</label>
                    <input type="month" value={periodo_fecha} onChange={(e) => setPeriodoFecha(e.target.value)} />
                </div>
            </div>
            <div className="flex flex-col gap-4 mb-4">
                <div className="flex flex-col gap-3">
                    <div className="w-full">
                        <ButtonSearch onClick={handleSearch} isLoading={loading} />
                    </div>
                    <div className="flex justify-between items-center w-full">
                        <div className="flex items-center gap-4">
                            {planillaData.length > 0 && (
                                <div style={{
                                    backgroundColor: '#f5f5f5',
                                    padding: '10px 20px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    border: '1px solid #e0e0e0'
                                }}>
                                    <span className="text-sm text-gray-700 uppercase tracking-wider" style={{ fontWeight: '400' }}>
                                        {getStatusText()}
                                    </span>
                                </div>
                            )}
                        </div>
                        <div className="flex items-center gap-3">
                            <Button
                                className={`px-4 py-2 rounded-lg text-xs font-semibold ${isApprovalDisabled() ? "bg-[#0b4d17] opacity-95 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"} text-white border-none`}
                                onClick={handleAprobar}
                                disabled={isApprovalDisabled()}
                            >
                                Aprobar y firmar
                            </Button>
                            {[5, 22, 8, 26].includes(Number(state.user?.perfil_id)) && (
                                <ButtonInsert onClick={handleAddRow} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="table-container shadow-sm overflow-x-auto">
                <Table bordered hover size="sm" className="text-[11px] m-0" style={{ minWidth: '2600px' }}>
                    <thead className="bg-[#14233a] text-white text-center align-middle">
                        <tr>
                            <th className="p-1" style={{ width: '40px' }}>N°</th>
                            <th className="p-1" style={{ minWidth: '130px' }}>AREA</th>
                            <th className="p-1" style={{ minWidth: '260px' }}>APELLIDOS Y NOMBRES</th>
                            <th className="p-1" style={{ minWidth: '170px' }}>CARGO</th>
                            <th className="p-1" style={{ minWidth: '190px' }}>EMPRESA</th>
                            <th className="p-1" style={{ minWidth: '100px' }}>RxH / FACTURA</th>
                            <th className="p-1" style={{ minWidth: '110px' }}>TOTAL A PAGAR<br />MES</th>
                            <th className="p-1" style={{ minWidth: '110px' }}>BONO POR<br />GESTIÓN</th>
                            <th className="p-1 bg-red-600" style={{ minWidth: '110px' }}>DESCUENTO<br />TARDANZA</th>
                            <th className="p-1 bg-yellow-400 text-black" style={{ minWidth: '130px' }}>IMPORTE NETO<br />A PAGAR</th>
                            <th className="p-1" style={{ minWidth: '110px' }}>DETRACCIÓN</th>
                            <th className="p-1" style={{ minWidth: '90px' }}>N° DNI</th>
                            <th className="p-1" style={{ minWidth: '190px' }}>N° CUENTA</th>
                            <th className="p-1" style={{ minWidth: '220px' }}>CCI</th>
                            <th className="p-1" style={{ minWidth: '150px' }}>BANCO</th>
                            <th className="p-1" style={{ minWidth: '175px' }}>N° CUENTA DE<br />DETRACCIÓN</th>
                            <th className="p-1" style={{ minWidth: '140px' }}>BANCO<br />DETRACCIÓN</th>
                            <th className="p-1" style={{ minWidth: '120px' }}>BOLETA DE<br />PAGO</th>
                            <th className="p-1" style={{ minWidth: '120px' }}>ESTADO<br />PAGO</th>
                            <th className="p-1 bg-[#E1D5E7] text-black" style={{ minWidth: '120px' }}>FECHA PAGO</th>
                            <th className="p-1" style={{ minWidth: '130px', whiteSpace: 'normal' }}>COMPROBANTE<br />DE PAGO</th>
                            {(showBtnRegistro || showBtnEstado) && <th className="p-1 text-center" style={{ minWidth: '90px' }}>ACCIONES</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {planillaData.length > 0 ? planillaData.map((row, index) => (
                            <tr key={index} className={`align-middle ${getRowClass(row)}`}>
                                <td>{index + 1}</td>
                                <td style={{ width: '155px', minWidth: '155px', maxWidth: '155px', overflow: 'hidden' }}>
                                    <span className="px-1 block truncate" title={row.area}>{row.area}</span>
                                </td>
                                <td>
                                    <span className="px-1">{row.apellidos_nombre}</span>
                                </td>
                                <td>
                                    <span className="px-1">{row.cargo}</span>
                                </td>
                                <td>
                                    <span className="px-1">{getEmpresaName(row.empresa_id)}</span>
                                </td>
                                <td>
                                    <span className="px-1">{row.rxh_factura || 'E001-'}</span>
                                </td>
                                <td className="text-center">
                                    <span>{formatSoles(row.pago_mes)}</span>
                                </td>
                                <td className="text-center">
                                    <span>{formatSoles(row.bono_gestion)}</span>
                                </td>
                                <td className="text-center bg-red-100">
                                    <span>{formatSoles(row.descuento)}</span>
                                </td>
                                <td className="bg-yellow-100 font-bold text-center">{formatSoles(row.importe_neto)}</td>
                                <td className="text-center">
                                    <span>{formatSoles(row.detraccion)}</span>
                                </td>
                                <td className="text-center">
                                    <span>{row.dni}</span>
                                </td>
                                <td className="text-center">
                                    <span>{row.n_cuenta}</span>
                                </td>
                                <td className="text-center">
                                    <span>{row.cci}</span>
                                </td>
                                <td className="text-center">
                                    <span>{row.banco_pago}</span>
                                </td>
                                <td className="text-center">
                                    <span>{row.n_cuenta_detraccion}</span>
                                </td>
                                <td className="text-center">
                                    <span>{row.banco_detraccion}</span>
                                </td>
                                <td className="text-center">
                                    <button
                                        onClick={() => {
                                            if (row.boleta_url) window.open(row.boleta_url, '_blank');
                                        }}
                                        className="p-1 rounded"
                                        style={{ cursor: row.boleta_url ? 'pointer' : 'default' }}
                                        title={row.boleta_url ? "Ver Boleta de Pago" : "Sin boleta disponible"}
                                    >
                                        <FileMinus size={18} style={{
                                            color: row.boleta_url ? '#3cb167' : '#f87171',
                                            opacity: row.boleta_url ? 1 : 0.4
                                        }} />
                                    </button>
                                </td>
                                <td className="text-center min-w-[120px]">
                                    {state.catalogos?.tipos?.find(t => t.categoria_id == 32 && String(t.tipo_id) === String(row.estado_pago_id))?.descripcion || '—'}
                                </td>
                                <td className="text-center">
                                    <span>{row.fecha_pago || '—'}</span>
                                </td>
                                <td className="text-center">
                                    <button
                                        onClick={() => {
                                            if (row.comprobante_url) window.open(row.comprobante_url, '_blank');
                                        }}
                                        className="p-1 rounded"
                                        style={{ cursor: row.comprobante_url ? 'pointer' : 'default' }}
                                        title={row.comprobante_url ? "Ver Comprobante de Pago" : "Sin comprobante disponible"}
                                    >
                                        <FileMinus size={18} style={{
                                            color: row.comprobante_url ? '#3cb167' : '#f87171',
                                            opacity: row.comprobante_url ? 1 : 0.4
                                        }} />
                                    </button>
                                </td>
                                {(showBtnRegistro || showBtnEstado) && (
                                    <td className="text-center">
                                        <div className="flex justify-center items-center gap-2">
                                            {showBtnRegistro && (
                                                <ButtonUpdate
                                                    onClick={() => { setSelectedItemPago(row); setRegistroPagoModal(true); }}
                                                    title="Actualizar Registro"
                                                />
                                            )}
                                            {showBtnEstado && Number(validationStatus?.aprobado_th) === 1 && (
                                                <ButtonUpdate
                                                    onClick={() => { setSelectedItemPago(row); setEstadoPagoModal(true); }}
                                                    title="Actualizar Estado de Pago"
                                                />
                                            )}
                                        </div>
                                    </td>
                                )}
                            </tr>
                        )) : (
                            <tr><td colSpan="22" className="text-center py-4 bg-white text-gray-400">No hay registros. Haga clic en Agregar para iniciar.</td></tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="font-bold border-t-2">
                            <td colSpan="9" className="text-right p-1"></td>
                            <td className="bg-yellow-200 p-1 text-center">{formatSoles(totalImporteNeto)}</td>
                            <td colSpan={(showBtnRegistro || showBtnEstado) ? 12 : 11} className="p-1"></td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
            <ModalRegistroPagoRhAdministracion
                isOpen={registroPagoModal}
                onClose={() => { setRegistroPagoModal(false); setSelectedItemPago(null); }}
                onRefresh={fetchDatos}
                item={selectedItemPago}
                periodo={periodo_fecha}
            />
            <ModalEstadoPagoRhAdministracion
                isOpen={estadoPagoModal}
                onClose={() => { setEstadoPagoModal(false); setSelectedItemPago(null); }}
                onRefresh={fetchDatos}
                item={selectedItemPago}
                periodo={periodo_fecha}
            />
            <ModalAgregarRhAdministracion
                isOpen={agregarModal}
                onClose={() => setAgregarModal(false)}
                onSave={handleSaveRow}
            />
        </div>
    );
}

export default RHAdministracion;
